import styled from 'styled-components';
import { Geography } from 'react-simple-maps';

export const CountyGeography = styled(Geography)`
  pointer-events: none;
`;
